import { Vehicle } from '../../model/Quote'
import { ImageUrlType } from '../../pages/vehicle-configurator/VehicleGallery'
import {
  getImacaVehicleImage,
  getImacaVehicleImageGallery,
} from './imacaVehicleImages'
import {
  getLocaleCountry,
  getModelYear,
  getPowertrainType,
  getVehicleBodyType,
  getVehicleMake,
  getVehicleModel,
  getVehicleTrim,
} from './vehicleImagesUtils'

const getVehicleImage = (vehicle: Vehicle, locale: string) => {
  return getImacaVehicleImage(vehicle, locale)
}

const getVehicleImageKey = (
  vehicle: Vehicle,
  locale: string,
  bodyColor?: string,
): string =>
  getVehicleMake(vehicle) +
  getVehicleModel(vehicle) +
  getModelYear(vehicle) +
  getVehicleBodyType(vehicle) +
  getVehicleTrim(vehicle) +
  getPowertrainType(vehicle) +
  getLocaleCountry(locale) +
  (bodyColor || '')

const getVehicleImageGallery = (
  vehicle: Vehicle,
  locale: string,
  bodyColor?: string,
): ImageUrlType[] => {
  return getImacaVehicleImageGallery(vehicle, locale, bodyColor)
}

export { getVehicleImage, getVehicleImageKey, getVehicleImageGallery }
